import React from 'react';

import { Dialog, DialogButton } from '@/shared/ui/overlays/Modal';
import type { CancelablePopupContent } from '@/shared/ui/overlays/Modal/type';

export type ConfirmationDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
} & CancelablePopupContent;

export const ConfirmationDialog = ({
  open,
  title,
  text,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      buttons={
        <>
          <DialogButton
            variant='outlined'
            onClick={onCancel}
          >
            {cancelText}
          </DialogButton>
          <DialogButton
            variant='contained'
            onClick={onConfirm}
          >
            {confirmText}
          </DialogButton>
        </>
      }
      open={open}
      title={title}
      onClose={onCancel}
    >
      <p className='text-base'>{text}</p>
    </Dialog>
  );
};
